module.exports = __webpack_public_path__ + "static/media/logo.509ca4a9.png";